import { DATASETS, PROVIDER } from '../../PartnerAccountForm/fields'

export const formatValuesToBE = values => {
  return {
    ...values,
    [DATASETS]: values[DATASETS].map(dataset => {
      return {
        external_id: dataset.value,
        name: dataset.label,
        [PROVIDER]: values[PROVIDER]
      }
    })
  }
}
